import { Box, Button } from "@chakra-ui/react";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { useNavigate } from "react-router-dom";

type BackButtonProps = {
  routeTo?: string;
};

export default function BackButton({ routeTo }: BackButtonProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    routeTo ? navigate(routeTo) : navigate(-1);
  };

  return (
    <Box alignSelf="flex-end" width="8rem" mb={4}>
      <Button
        onClick={handleClick}
        leftIcon={<MdOutlineKeyboardDoubleArrowLeft />}
        bgColor="#85c872"
        w="100%"
        color="white"
        borderRadius="12px"
        _hover={{
          bgColor: "#54A23F",
        }}
      >
        Voltar
      </Button>
    </Box>
  );
}
